import React, { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { useNavigate } from "react-router-dom";
import { useGetPatientQuery } from "@store/patientApi";
import SuccessPageContent from "@components/SuccessPageContent";
import { Box } from "@mui/material";

const OnboardingSuccess: FC = () => {
  const patientId = useSelector(
    (state: RootState) => state.home.selectedPatientId,
  );
  const navigate = useNavigate();
  const { data: patient, isLoading } = useGetPatientQuery(patientId!, {
    skip: !patientId,
  });

  useEffect(() => {
    if (!patient && !isLoading) {
      navigate("/onboarding/profile");
    }
  }, [patient, navigate, isLoading]);

  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <SuccessPageContent />
    </Box>
  );
};

export default OnboardingSuccess;
